export default [
  // {
  //     divClass: "loader vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2",
  //     dataName: "totalClient",
  //     label: "Total Client",
  //     icon: "UsersIcon",
  //     type: "statisticsiconright",
  //     value: ""
  // },
  // {
  //     divClass: "loader vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2",
  //     dataName: "totalVehicle",
  //     label: "Total Vehicle",
  //     icon: "TruckIcon",
  //     type: "statisticsiconright",
  //     value: ""
  // },
  // {
  //     divClass:"vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base",
  //     dataName: "workOrder",
  //     label: "Work Order",
  //     icon: "TruckIcon",
  //     viewDetailsPath:"/form/wo/all",//path to the actual module
  //     filterUrl: "getWoDB",//in this componenent we have dropdown for filter
  //     type: "activityMonitor",
  //     showViewDetails: true,
  //     value: ""
  // },
  // {
  //   divClass: "vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base",
  //   dataName: "summons",
  //   label: "Unpaid Summons",
  //   icon: "TruckIcon",
  //   viewDetailsPath: "/form/su/all", //path to the actual module
  //   filterUrl: "getFilteredSummonDB", //in this componenent we have dropdown for filter
  //   type: "activityMonitor",
  //   showViewDetails: true,
  //   value: ""
  // },
  {
    // divClass:"loader vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base",
    divClass: "loader vx-col w-full pb-10",
    dataName: "cases",
    label: "Cases",
    icon: "TruckIcon",
    viewDetailsPath: "/form/wo/all", //path to the actual module
    filterUrl: "getCaseDb", //in this componenent we have dropdown for filter
    type: "caseTracker",
    value: ""
  },
  {
    divClass: "vx-col w-full",
    dataName: "openCase",
    label: "Latest 5 Open Cases",
    icon: "TruckIcon",
    viewDetailsPath: "/form/wo/all", //path to the actual module
    filterUrl: "getCaseDb", //in this componenent we have dropdown for filter
    type: "gridTable",
    value: ""
  }
];
